<template>
    <h2 class="nav-tab-wrapper woo-nav-tab-wrapper">
        <router-link :to="{ name: 'RequestAQuote'}" :class="['nav-tab', {'nav-tab-active': $route.path === '/request-for-quote' }]">
            {{ __('Quotes List', 'dokan') }}
        </router-link>
        <router-link :to="{ name: 'RequestAQuoteRules'}" :class="['nav-tab', {'nav-tab-active': $route.path === '/request-for-quote/quote-rules' } ]">
            {{ __('Quote Rules', 'dokan') }}
        </router-link>
    </h2>
</template>

<script>
export default {
    name: 'Tabs',
    methods: {
        test() {
            console.log(this.$route.path);
        },
    }
}
</script>
